import React, { useState, ReactNode, RefObject } from "react";
import classNames from "classnames";
import styles from "./Dropdown.module.scss";

import IconMS from "components/utils/IconMS/IconMS";
import useClickOutside from "../../../utils/useClickOutside";
import { useTheme } from "../../../utils/useTheme";
import useEscape from "../../../utils/useEscape";

export interface DropdownProps {
  buttonLabel?: string;
  labels?: {
    closeDropdownLabel: string;
    openDropdownLabel: string;
  };
  inHeader?: boolean;
  children?: ReactNode;
  className?: string;
  dropdownRef?: RefObject<HTMLDivElement | null>;
}

const Dropdown: React.FC<DropdownProps> = ({
  buttonLabel,
  labels = {
    closeDropdownLabel: "close",
    openDropdownLabel: "open",
  },
  inHeader,
  children,
  className,
  dropdownRef,
}) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const theme = useTheme();

  const handleDropdownClick = () => {
    setShowDropdown(!showDropdown);
  };
  const correctDropdownRef = dropdownRef || React.createRef<HTMLDivElement>();

  //@ts-ignore
  useClickOutside(
    [correctDropdownRef],
    () => {
      setShowDropdown(false);
    },
    showDropdown
  );

  useEscape(() => setShowDropdown(false));

  return (
    <div
      className={classNames(styles.dropdown, styles[theme], className, {
        [styles.hasDarkBackground]: theme === "dark",
      })}
      ref={correctDropdownRef}
    >
      <button
        className={styles.dropdownLabel}
        onClick={handleDropdownClick}
        aria-label={
          showDropdown ? labels.closeDropdownLabel : labels.openDropdownLabel
        }
        aria-expanded={showDropdown}
        aria-haspopup="menu"
      >
        <span>{buttonLabel}</span>
        <IconMS
          name="expand_more"
          className={classNames(styles.chevronDown, {
            [styles.isOpen]: showDropdown,
          })}
          size="24px"
        />
      </button>
      {inHeader ? (
        <nav role="menu">
          <ul
            className={classNames(styles.dropdownContent, styles.menu, {
              [styles.showDropdownContent]: showDropdown,
            })}
            role="menu"
          >
            {children}
          </ul>
        </nav>
      ) : (
        <ul
          className={classNames(styles.dropdownContent, {
            [styles.showDropdownContent]: showDropdown,
          })}
        >
          {children}
        </ul>
      )}
    </div>
  );
};

export default Dropdown;
